var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBraze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h10zM7 2a5 5 0 0 0-5 5c0 1.234.351 1.809.574 2.043.65.648 1.745.51 2.34-.086.352-.36.592-.815.692-1.308.096-.521.437-2.585.607-3.649H5.128c-.096 0-.181-.043-.17-.16.017-.179.045-.356.085-.531a.18.18 0 0 1 .17-.16h1.49c.127 0 .212.064.308.213a.521.521 0 0 1 .095.425L6.787 5.65a2.01 2.01 0 0 1 1.064-.287c1.032 0 1.809 1.095 1.702 2.478-.106 1.383-1.021 2.5-2.106 2.5-.638 0-1.277-.361-1.607-1.074a2.384 2.384 0 0 1-.212.245c-.724.712-1.65.946-2.48.68A5 5 0 1 0 7 2zm.777 4.191c-.67 0-1.245.745-1.34 1.66-.14 1.096.372 1.67 1 1.67.627 0 1.18-.755 1.276-1.67.096-.915-.266-1.66-.936-1.66z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBraze);
export default __webpack_public_path__ + "static/media/braze.fc0f062a9a8a5a2497e8aef1ed7616ad.svg";
export { ForwardRef as ReactComponent };